import { useSelector } from "react-redux"
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactBeforeSliderComponent from 'react-before-after-slider-component';
import { useState } from "react";
import CountUp from 'react-countup';
import { useRef } from "react";

const ZigZag = ({ children }) => {


    return (
        <>
            <div className="zigzag"  >

                {children}
            </div>


        </>
    );
}


/**
 * ZigZag.Card - A React component that renders a card with optional heading, title, description, and a large graphic.
 *
 * @param {Object} props - The props object.
 * @param {(string|Object)} props.title - The title of the card. Can be a string or an object with a `custom` element.
 * @param {(string|Object)} props.description - The description of the card. Can be a string or an object with a `custom` element.
 * @param {Object} props.largeGraphic - The large graphic for the card.
 * @param {string} [props.largeGraphic.image] - The source URL of the large graphic.
 * @param {string} [props.largeGraphic.alt] - The alt text for the large graphic.
 * @param {React.ReactNode} [props.largeGraphic.custom] - Custom JSX content for the large graphic.
 * @param {Object} props.heading - The heading of the card.
 * @param {string} [props.heading.text] - The text content of the heading.
 * @param {string} [props.heading.image] - The source URL of the image in the heading.
 * @param {string} [props.heading.alt] - The alt text for the image in the heading.
 * @param {React.ReactNode} [props.heading.custom] - Custom JSX content for the heading.
 *
 * @returns {JSX.Element} The rendered ZigZag card component.
 */

ZigZag.Card = ({ title, description, largeGraphic, heading }) => {

    return (
        <div className="zigzag-card">
            <div className="zigzag-text" data-aos="fade-up" >

                {heading?.text && <span>{heading.text}</span>}
                {heading?.image && heading?.alt && <img src={heading.image} alt={heading.alt} />}
                {heading?.custom && heading?.custom}

                {typeof title == 'string' && <h1>{title}</h1>}
                {title?.custom && title?.custom}

                {typeof description == 'string' && <p>{description}</p>}
                {description?.custom && description?.custom}
            </div>
            {largeGraphic?.image && largeGraphic?.alt && <img src={largeGraphic.image} alt={largeGraphic.alt} />}
            {largeGraphic?.video && largeGraphic.video && <video
                poster={largeGraphic.thumbnail}
                autoPlay muted loop playsInline src={largeGraphic.video} />}
            {largeGraphic?.custom && largeGraphic?.custom}
        </div>
    )

}


export default ZigZag;


